module.exports = "/templates/bds/public/images/e2713ad901664d4f5f1c166a07bcf2a1.png";